import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { capitalizeFirstLetter } from '../util/string-util.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'

@jsonClass('StaticEntityEntry')
export class StaticEntityEntry {
	@jsonProperty(String) identifier!: string
	@jsonMapProperty(String, String) values: Map<string, string> = new Map()

	get id() {
		return this.values.get('id')
	}

	constructor(init?: Partial<StaticEntityEntry>) {
		assignCommonProperties(this, init)
	}

	getCapitalizedIdentifier() {
		return capitalizeFirstLetter(this.identifier)
	}

	isOtherEntry() {
		return this.values.get('$isOther') == 'true'
	}
}
